import Layout from '../../views/Layout'

const humanResourcesRoutes = {
    path: '/humanresources',
    component: Layout,
    name: 'HumanResources',
    meta: {
        title: '人力资源',
        icon: 'User'
    },
    children: [
        {
            path: 'contacts',
            name: 'contacts',
            component: () => import('@/views/humanresources/contacts/index.vue'),
            meta: {
                title: '通讯录',
                keepAlive: true
            }
        },
        {
            path: 'contacts/detail',
            name: '员工详情',
            component: () => import('@/views/humanresources/contacts/detail.vue'),
            meta: {
                title: '员工详情',
                hidden: true,
                keepAlive: true,
                parentPath: '/humanresources/contacts',
                parentName: '通讯录'
            }
        }
    ]
}

export default humanResourcesRoutes 